"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:jsx-no-lambda

var react_1 = __importDefault(require("react"));

var react_slick_1 = __importDefault(require("react-slick"));

require("./BB8Carousel.scss");

var BB8CarouselItem_1 = __importStar(require("./BB8CarouselItem"));

function CustomArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return react_1.default.createElement("div", {
    className: className,
    style: style,
    onClick: onClick
  }, react_1.default.createElement("img", {
    src: require("../assets/images/bb8-carousel-arrow-active.svg")
  }));
}

var BB8Carousel =
/** @class */
function (_super) {
  __extends(BB8Carousel, _super);

  function BB8Carousel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      selectedItem: {
        id: -9999
      }
    };
    return _this;
  }

  BB8Carousel.getDerivedStateFromProps = function (nextProps, prevState) {
    if (nextProps.selectedItemId && !prevState.selectedItem || prevState.selectedItem.id === -9999) {
      var selectedItem = nextProps.data.find(function (item) {
        return item.id === nextProps.selectedItemId;
      });

      if (selectedItem) {
        if (nextProps.onSelect) {
          nextProps.onSelect(selectedItem);
        }

        return __assign({}, prevState, {
          selectedItem: selectedItem
        });
      }
    }

    return __assign({}, prevState);
  };

  BB8Carousel.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        data = _a.data,
        styleType = _a.styleType,
        onSelect = _a.onSelect,
        allowEdit = _a.allowEdit,
        editItem = _a.editItem,
        slickProps = __rest(_a, ["data", "styleType", "onSelect", "allowEdit", "editItem"]);

    var settings = __assign({}, slickProps, {
      dots: true,
      infinite: this.props.data && this.props.data.length > 3,
      nextArrow: react_1.default.createElement(CustomArrow, null),
      prevArrow: react_1.default.createElement(CustomArrow, null)
    });

    return react_1.default.createElement(react_slick_1.default, __assign({
      className: "BB8Carousel"
    }, settings), this.props.children, this.props.data.map(function (item) {
      return react_1.default.createElement(BB8CarouselItem_1.default, {
        key: item.id + "-carousel-item",
        item: item,
        allowEdit: _this.props.allowEdit && item.id !== "unmapped",
        select: function select(thisBB8CarouselItem) {
          return _this.selectCurrentPanel(thisBB8CarouselItem);
        },
        clickEdit: function clickEdit(thisBB8CarouselItem) {
          return _this.props.editItem && _this.props.editItem(thisBB8CarouselItem);
        },
        selectedItem: _this.state.selectedItem,
        styleType: _this.props.styleType || BB8CarouselItem_1.BB8CarouselItemStyle.default
      });
    }));
  };

  BB8Carousel.prototype.selectCurrentPanel = function (item) {
    var _this = this;

    this.setState({
      selectedItem: item
    }, function () {
      if (_this.props.onSelect) {
        _this.props.onSelect(item);
      }
    });
  };

  return BB8Carousel;
}(react_1.default.Component);

exports.default = BB8Carousel;